import { render, staticRenderFns } from "./ServerDisplay.vue?vue&type=template&id=599a4bc4&"
import script from "./ServerDisplay.vue?vue&type=script&lang=ts&"
export * from "./ServerDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports